// services/otpService.js or any file of your choice

import axios from "axios";

export async function sendOtpToServer(mobileNo) {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_COLLEGE_ERP_API}send-otp`,
      {
        mobileNo: mobileNo,
      }
    );

    console.log("OTP sent response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error sending OTP:", error.response?.data || error.message);
    throw error;
  }
}
//mobile-verify-otp",

export async function sendMobileVeirfyOtpToServer(mobileNo, brand) {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_COLLEGE_ERP_API}mobile-verify-otp`,
      {
        mobileNo: mobileNo,
        brand: brand,
      }
    );

    console.log("OTP sent response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error sending OTP:", error.response?.data || error.message);
    throw error;
  }
}

export async function verifyOtp(otpDetails, otp, userData) {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_COLLEGE_ERP_API}verify-otp`,
      {
        token: otpDetails.data.token,
        otp: otp && otp.trim(),
      },
   //   {
   //     headers: {
   //       "Content-Type": "application/json",
   //       Authorization: `Bearer ${userData.token}`,
   //     },
   //   }
    );

    console.log("OTP verification success:", response.data);
    return response.data;
  } catch (error) {
    console.error(
      "OTP verification failed:",
      error.response?.data || error.message
    );
    throw error;
  }
}
//  verifyOtpnonmember(formattedOtpDetails, otp, "customer", "Kyts", forgotMobile)
export async function verifyOtpnonmember(otpDetails, otp, id,branch, forgotMobile) {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_COLLEGE_ERP_API}verify-otp-non-member`,
      {
        token: otpDetails.data.token,
        otp: otp && otp.trim(),
        id: id,
        branch: branch,
        mobileNo: forgotMobile
      },
      
    );

    console.log("OTP verification success:", response.data);
    return response.data;
  } catch (error) {
    console.error(
      "OTP verification failed:",
      error.response?.data || error.message
    );
    throw error;
  }
}
//verify-otp-non-member"